import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { goToProductRegistrationSearch } from '@/utils/Common/Redirects';

const Timeline = ({ steps, t, currentStep }) => {
  const history = useHistory();

  const handleStepClick = e => {
    const clickedStepNum = parseInt(e.target.dataset.ref, 10);

    switch (currentStep) {
      case 2:
        if (clickedStepNum === 1) {
          history.goBack();
        }
        break;
      case 3:
        if (clickedStepNum === 2) {
          history.goBack();
        }
        if (clickedStepNum === 1) {
          history.replace(goToProductRegistrationSearch());
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className='dln-timeline'>
      <ol className='dln-timeline__container'>
        {steps.map(step => (
          <li
            key={step.num}
            className={`dln-timeline__step ${
              step.active ? 'dln-timeline__step--active' : ''
            } ${step.completed ? 'dln-timeline__step--completed' : ''}`}
            data-ref={step.num}
            role={step.completed ? 'button' : 'presentation'}
            {...(step.completed && {
              onClick: handleStepClick,
              onKeyDown: handleStepClick,
            })}
          >
            {step.label && (
              <span className='dln-timeline__label' data-ref={step.num}>
                <span>{t(step.label)}</span>
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

Timeline.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  t: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default memo(Timeline);
